<tm-menubar-button [component]="componentType"
                   [tooltip]="panelLabel"
                   [panelTitle]="panelLabel"
                   icon="components_filter"></tm-menubar-button>
